export default "__VITE_ASSET__f2a0a41f__"